import React from "react";
import "../Assets/Styles/Emails.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Seg from "../Assets/Images/seg.png";
import Promo from "../Assets/Images/promo.png";
import PromoFr from "../Assets/Images/promo-fr.png";
import SegFr from "../Assets/Images/seg-fr.png";
import Shop from "../Assets/Images/shop.png";
import SSGP from "../Assets/Images/ssgp.png";
import GTA from "../Assets/Images/gta.png";
const Emails = () => {
  return (
    <div>
      <div className="card-container">
        <div className="row">
        <div className="col-md-4">
          {/* Segmented Manufacturing Card */}
          <div className="card">
            <h2>Segmented </h2>

            <div className="row">
              <div className="col-md-6">
                <Link to={"/segmented-en"}>
                  <img src={Seg} alt="" />
                  <div className="item green">
                    <h3>English</h3>
                  </div>
                </Link>
              </div>
              <div className="col-md-6">
                <Link to={"/segmented-fr"}>
                  <img src={SegFr} alt="" />
                  <div className="item pink">
                    <h3>French</h3>
                  </div>
                </Link>
              </div>
            </div>

            <div className="more">Select Template</div>
          </div>
        </div>
        <div className="col-md-4">
          {/* Promotional Card */}
          <div className="card">
            <h2>Promotional</h2>
            <div className="row">
              <div className="col-md-6">
                <Link to={"/promotional-en"}>
                  <img src={Promo} alt="" />
                  <div className="item green">
                    <h3>English</h3>
                  </div>
                </Link>
              </div>
              <div className="col-md-6">
                <Link to={"/promotional-fr"}>
                  <img src={PromoFr} alt="" />
                  <div className="item pink">
                    <h3>French</h3>
                  </div>
                </Link>
              </div>
            </div>
            <div className="more">Select Template</div>
          </div>
        </div>
        
        <div className="col-md-4">
          {/*SSGP Card */}
          <div className="card">
            <h2>GMA Campaign</h2>
            <div className="row">
              <div className="col-md-6">
                <Link to={"/gma"}>
                  <img src={GTA} alt="" />
                  <div className="item green">
                    <h3>Bilingual</h3>
                  </div>
                </Link>
              </div>
              <div className="col-md-6">
                <Link to={"/gma-fr"}>
                  <img src={GTA} alt="" />
                  <div className="item pink">
                    <h3>FR</h3>
                  </div>
                </Link>
              </div>
            </div>
            <div className="more">Select Template</div>
          </div>
        </div>
        <div className="col-md-4">
          {/*SSGP Card */}
          <div className="card">
            <h2>SSGP</h2>
            <div className="row">
              <div className="col-md-6">
                <Link to={"/ssgp-en"}>
                  <img src={SSGP} alt="" />
                  <div className="item green">
                    <h3>English</h3>
                  </div>
                </Link>
              </div>
              <div className="col-md-6">
                <Link to={"/ssgp-fr"}>
                  <img src={SSGP} alt="" />
                  <div className="item pink">
                    <h3>French</h3>
                  </div>
                </Link>
              </div>
            </div>
            <div className="more">Select Template</div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Emails;
